/**
 * 防抖函数
 *
 * @param {function} func 需要处理的函数
 * @param {number} delay 延迟时间
 */
const debounce = (func, delay = 1000) => {
  let timer;
  function debounced(...args) {
    debounced.cancel();
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  }

  debounced.cancel = function () {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
  };
  return debounced;
};

export default debounce;
